export var BrowersEnvType;
(function (BrowersEnvType) {
    BrowersEnvType["FSApp"] = "FSApp";
    BrowersEnvType["FYApp"] = "FYApp";
    BrowersEnvType["SfExpressApp"] = "SfExpressApp";
    BrowersEnvType["WeChatMiniApp"] = "WeChatMiniApp";
    BrowersEnvType["WeChatApp"] = "WeChatApp";
    BrowersEnvType["AliPayMiniApp"] = "AliPayMiniApp";
    BrowersEnvType["AliPayApp"] = "AliPayApp";
    BrowersEnvType["ByteDanceMiniApp"] = "ByteDanceMiniApp";
    BrowersEnvType["DouYinApp"] = "DouYinApp";
    BrowersEnvType["TouTiaoApp"] = "TouTiaoApp";
    BrowersEnvType["KuaiShouMiniApp"] = "KuaiShouMiniApp";
    BrowersEnvType["BaiduMiniApp"] = "BaiduMiniApp";
    BrowersEnvType["PC"] = "PC";
    BrowersEnvType["H5"] = "H5";
    BrowersEnvType["Web"] = "Web";
    BrowersEnvType["Node"] = "Node";
    BrowersEnvType["UNKNOW"] = "UNKNOW";
})(BrowersEnvType || (BrowersEnvType = {}));
const ua = navigator && navigator.userAgent ? navigator.userAgent.toLowerCase() : '';
/**
 * 是否Node环境
 */
export const isNode = typeof process !== 'undefined' && !!(process.versions && process.versions.node);
/**
 * 是否丰源微应用
 */
export const isFYApp = ua === 'sfsgsweb';
/**
 * 是否丰声app
 */
export const isFSApp = /sf-service-mobile/i.test(ua);
/**
 * 是否顺丰速运App
 */
export const isSfExpressApp = /SFEXPRESSAPP/i.test(ua);
/**
 * 是否微信小程序webview
 * @Link https://developers.weixin.qq.com/miniprogram/dev/component/web-view.html
 */
export const isWeChatMiniApp = (/MicroMessenger/i.test(ua) && /miniprogram/i.test(ua)) || window.__wxjs_environment === 'miniprogram';
/**
 * 是否微信App（微信浏览器）
 */
export const isWeChatApp = /MicroMessenger/i.test(ua) && !isWeChatMiniApp;
/**
 * 是否支付宝App内部浏览器打开
 */
export const isAliPayMiniApp = /AliApp/i.test(ua) && /MiniProgram/i.test(ua);
/**
 * 是否支付宝App内部浏览器打开
 */
export const isAliPayApp = /AliApp/i.test(ua) && !isAliPayMiniApp;
/**
 * 是否字节小程序
 */
export const isByteDanceMiniApp = /toutiaomicroapp/i.test(ua);
/**
 * 是否抖音App
 */
export const isDouYinApp = /aweme/i.test(ua);
/**
 * 今日头条App
 */
export const isTouTiaoApp = /NewsArticle/i.test(ua);
/**
 * 快手小程序
 */
export const isKuaiShouMiniApp = /miniProgram/i.test(ua) && typeof ks !== 'undefined' && ks !== null && typeof ks.showToast !== 'undefined';
/**
 * 百度小程序
 */
export const isBaiduMiniApp = /swan\//i.test(ua) || /^webswan-/i.test(window.name);
/**
 * 是否移动端浏览器
 */
export const isMoible = /iphone|ipod|ipad|ipad|Android|nokia|blackberry|webos|webos|webmate|bada|lg|ucweb|skyfire|sony|ericsson|mot|samsung|sgh|lg|philips|panasonic|alcatel|lenovo|cldc|midp|wap|mobile|sfsgsweb/i.test(ua);
/**
 * 是否PC端
 */
export const isPc = !isMoible;
/**
 * 是否web
 */
export const isWeb = typeof window !== 'undefined' && 'onload' in window;
const initBrowerEnv = function initBrowerEnv() {
    if (isFYApp)
        return BrowersEnvType.FYApp;
    if (isFSApp)
        return BrowersEnvType.FSApp;
    if (isSfExpressApp)
        return BrowersEnvType.SfExpressApp;
    if (isWeChatMiniApp)
        return BrowersEnvType.WeChatMiniApp;
    if (isWeChatApp)
        return BrowersEnvType.WeChatApp;
    if (isAliPayMiniApp)
        return BrowersEnvType.AliPayMiniApp;
    if (isAliPayApp)
        return BrowersEnvType.AliPayApp;
    if (isByteDanceMiniApp)
        return BrowersEnvType.ByteDanceMiniApp;
    if (isDouYinApp)
        return BrowersEnvType.DouYinApp;
    if (isTouTiaoApp)
        return BrowersEnvType.TouTiaoApp;
    if (isKuaiShouMiniApp)
        return BrowersEnvType.KuaiShouMiniApp;
    if (isBaiduMiniApp)
        return BrowersEnvType.BaiduMiniApp;
    if (isNode)
        return BrowersEnvType.Node;
    if (!isWeb) {
        return BrowersEnvType.UNKNOW;
    }
    if (isMoible) {
        return BrowersEnvType.H5;
    }
    return BrowersEnvType.PC;
};
/**
 * 当前浏览器环境
 * @link https://confluence.sf-express.com/pages/viewpage.action?pageId=334926452
 */
export const browersEnv = initBrowerEnv();
//# sourceMappingURL=browers_env.js.map